export default __webpack_public_path__ + "static/media/Enrico.ceda89c8.png";